<template>
    <div>
        <div v-if="display" class="alert"
             v-bind:class="model.coupon.isValid ? 'alert-success' : 'alert-danger'">
            {{model.coupon.string}}
        </div>
    </div>
</template>

<script>
    import VueFormGenerator from "vue-form-generator/dist/vfg.js";

    Vue.use(VueFormGenerator);

    export default {

        props: ["model", "schema", "checkout"],

        data: function () {
            return {
                display: false,
                couponLoadedOnInit: false,
                timing: "manual",

            }
        },

        methods: {

            init: function () {

                this.model.coupon = {
                    isValid: false,
                    code: "",
                    discount: 0,
                    string: ""
                };

                let coupon = this.checkIfCouponCodeIsSet();

                this.schema.groups.push({
                        fields: [
                            {
                                type: "input",
                                inputType: "text",
                                label: "Koda kupona",
                                model: "coupon.code",
                                hint: "V primeru, da ste prejeli kupon, ga vpišite zgoraj.",
                                buttons: [
                                    {
                                        classes: "btn-coupon",
                                        label: "Preveri kupon",
                                        onclick: function (model, field) {
//                                            field.hint = "TTESST";
//                                            field.styleClasses = "coupon-field col-sm-12 has-error";
                                            if (model.coupon.code === "") {
                                                alert("Prosimo najprej vpišite kodo kupona.");
                                                return;
                                            }

                                            let axiosResponse = this.validateCouponCode("manual");

                                            axiosResponse.then(function (response) {
                                                if (response.data.isValid) {
                                                    field.styleClasses = "coupon-field col-sm-12 has-success";
                                                } else {
                                                    field.styleClasses = "coupon-field col-sm-12 has-error";
                                                }

                                                field.hint = response.data.string;
                                            }.bind(field))


                                        }.bind(this)
                                    },
                                ],
                                styleClasses: "coupon-field col-sm-12",
                                visible: function (model) {
                                    return !this.couponLoadedOnInit && model.price_total > 0;
                                }.bind(this)
                            }
                        ]
                    },
                );


            },


            checkIfCouponCodeIsSet() {
                let coupon = this.$route.query.kupon;

                if (!coupon) {
                    return false;
                }


                console.log(this.model);
                this.model.coupon.code = coupon;

                this.validateCouponCode("init");


            },


            validateCouponCode(timing) {

                // it does not work by binding 2 varaiables to promise
                this.timing = timing;

                let component = this;

                let axiosResponse = this.axiosCheckCoupon();

                axiosResponse.then(function (response) {

                    console.log("response1");
                    console.log(response);

//                    component.model.coupon.code = response.data.code;
                    component.model.coupon.discount = response.data.discount;
                    component.model.coupon.string = response.data.string;
                    component.model.coupon.isValid = response.data.isValid;

                    if (response.data.state === "valid") {
                        Event.$emit("prijavnica_update_totals");
                    }

                    if (component.timing === "init") {
                        component.display = true;
                        if (response.data.state === "valid") {
                            component.couponLoadedOnInit = true;
                        }
                    }
//                        console.log(timing);
//                        this.model.coupon.discount = response.data.discount;
//                        this.model.coupon.discount = response.data.discount;
                }.bind(component))
                    .catch(function (error) {
                        console.log(error);
                    }.bind(component));

                return axiosResponse;

            },


            axiosCheckCoupon: function () {
                return axios.post("/coupons/check/", {
                    checkout_id: this.checkout.id,
                    code: this.model.coupon.code
                })
            }
        }

    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/modules/Coupon.vue